var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Business Icon Set") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.83,17,40,2.17A4,4,0,0,0,37.17,1H12A4,4,0,0,0,8,5V59a4,4,0,0,0,4,4H52a4,4,0,0,0,4-4V19.83A4,4,0,0,0,54.83,17ZM40,7.83,49.17,17H40ZM12,59V5H36V17a4,4,0,0,0,4,4H52V59Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47,30H31a2,2,0,0,0,0,4H47a2,2,0,0,0,0-4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.17,27,19,30.17,18.83,30A2,2,0,0,0,16,32.83l2.29,2.29a1,1,0,0,0,1.42,0L25,29.83A2,2,0,0,0,22.17,27Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47,46H31a2,2,0,0,0,0,4H47a2,2,0,0,0,0-4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.17,43,19,46.17,18.83,46A2,2,0,0,0,16,48.83l2.29,2.29a1,1,0,0,0,1.42,0L25,45.83A2,2,0,0,0,22.17,43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanning);
export default __webpack_public_path__ + "static/media/planning.947ea190b10e999520da1bc660a4d3ba.svg";
export { ForwardRef as ReactComponent };